import { createStore } from 'vuex'
import Axios from "axios";
import router from '../router'
// Config
import ConfigStore from './base/config.js';
import AuthStore from './base/auth.js';
import UploadStore from "./tools/upload.js";

// Tools
import ModalsStore from "./tools/modals.js";
import ToastsStore from "./tools/toasts.js";

// Resources
import UsersStore from './resources/users'
import SettingsStore from './resources/settings'

import ProjectsStore from './resources/projects'
import BuildingsStore from "./resources/buildings"
import FloorsStore from "./resources/floors"
import UnitsStore from "./resources/units"
import StatusesStore from "./resources/statuses"
import ImagesStore from "./resources/files"
import ContactsStore from "./resources/contacts"
import CategoriesStore from "./resources/categories"
import CorporationsStore from "./resources/corporations"
import DomainsStore from "./resources/domains"
import VideosStore from "./resources/videos"
import ToursStore from "./resources/tours"
import PagesStore from "./resources/pages"
import SourceImportsStore from "./resources/source_imports"

import FrontOfficeStore from "./resources/frontoffice"

const store = createStore({
    modules: {
        auth: AuthStore,
        config: ConfigStore,
        upload: UploadStore,

        modals: ModalsStore,
        toasts: ToastsStore,

        users: UsersStore,
        settings: SettingsStore,

        projects: ProjectsStore,
        buildings: BuildingsStore,
        floors: FloorsStore,
        units: UnitsStore,
        statuses: StatusesStore,
        files: ImagesStore,
        contacts: ContactsStore,
        categories: CategoriesStore,
        corporations: CorporationsStore,
        domains: DomainsStore,
        videos: VideosStore,
        tours: ToursStore,
        pages: PagesStore,
        source_imports: SourceImportsStore,

        frontoffice: FrontOfficeStore,
    }
});

Axios.interceptors.response.use(
    (response) => {
        return response;
    },
    function (error) {
        if(error.response.status === 500) {
            store.dispatch('toasts/add', {type: 'error', message: error.response.data.message}, {root: true})
        }

        if(error.response.status === 429) {
            store.dispatch('toasts/add', {type: 'error', message: 'Trop de tentative de connexion, veuillez patienter'}, {root: true})
        }

        // skipAuthRedirect: the guest-maintenance probe must not replace that page with login.
        if ((error.response.status === 401 || error.response.status === 419) && !error.config.skipAuthRedirect) {
            router.push({ path: "/login"});
        }

        if (error.response.status === 404) {
            router.push({ name: '404'});
        }

        return Promise.reject(error.response);
    }
);

export default store;
